/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IRichtextData } from './richtext.data';
import { IRichtextProps } from './richtext.props.autogenerated';

export interface IRichtextViewProps extends IRichtextProps<IRichtextData> {}

/**
 *
 * Richtext component
 * @extends {React.PureComponent<IRichtextProps<IRichtextData>>}
 */
class Richtext extends React.PureComponent<IRichtextProps<IRichtextData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default Richtext;
